module.exports = __webpack_public_path__ + "static/media/sn.4c526809.svg";